// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"_2bgKLd","headerContainer":"t7VbxS","active":"_1EGXg6","header":"_3wrUP3","itemContainer":"_38fm5y"};